import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { type SellerPromotionV2 } from '@redteclab/api/clients/bully'
import { IconInfo } from '@redteclab/icons'

import { useOpenableControls } from '../../../../../generic-hooks'
import {
  getFormattedPromotionDiscountedAmountOrPercentage,
  productAccessorIsSellerPromotionWithVoucherCode,
} from '../../../../models'

import { ProductSellerVoucherLabelDiscountDialog } from './ProductSellerVoucherLabelDiscountDialog'

type ProductSellerVoucherLabelDiscountProps = {
  sellerPromotion: SellerPromotionV2
}

export const ProductSellerVoucherLabelDiscount: FC<
  ProductSellerVoucherLabelDiscountProps
> = ({ sellerPromotion }) => {
  const modalControls = useOpenableControls()
  const intl = useIntl()

  if (!productAccessorIsSellerPromotionWithVoucherCode(sellerPromotion)) {
    return null
  }

  return (
    <>
      <ProductSellerVoucherLabelDiscountDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
        sellerPromotion={sellerPromotion}
      />
      <button
        className="flex items-center gap-1 whitespace-nowrap rounded-full bg-light-tertiary px-3 py-1 text-xs"
        data-qa-id="product-seller-voucher-explainer-trigger"
        onClick={modalControls.handleOpen}
        type="button"
      >
        <FormattedMessage
          id="seller.promotion.product.discount.withCode"
          values={{
            discountPercent: getFormattedPromotionDiscountedAmountOrPercentage(
              sellerPromotion,
              intl,
            ),
          }}
        />
        <IconInfo className="size-4" />
      </button>
    </>
  )
}
